import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/saira.css";
import { ThemeProvider, ThemeContext } from './themecontext';
import { history } from './history';
// import { PublicClientApplication } from "@azure/msal-browser";
// import { MsalProvider } from "@azure/msal-react";
// import { msalConfig } from "./authConfig";

// src/authConfig.js
// const msalConfig = {
//   auth: {
//     clientId: "1347162f-690d-4c5b-b473-6cc9f7e856ac",
//     authority: "https://login.microsoftonline.com/eed8bd68-7eb7-4b81-ae8a-31ee9de8cc3f",
//     redirectUri: "http://localhost:3016",
//   },
//   cache: {
//     cacheLocation: "localStorage", // or "sessionStorage"
//     storeAuthStateInCookie: false,
//   },
// };

// const msalInstance = new PublicClientApplication(msalConfig);
// Creating root and rendering the application
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <ErrorBoundary>
  // <MsalProvider instance={msalInstance}>
    <ThemeProvider>
      <Router history={history}>
        <App />
      </Router>
    </ThemeProvider>
  // </MsalProvider>
  // </ErrorBoundary>
);